
export const STUDIO_THEME = {
  typography: {
    // Labels for collapsible sections, etc.
    sectionLabel: "text-[11px] font-medium uppercase tracking-[0.1em] transition-all",
    // Standard control labels
    controlLabel: "text-[12px] font-normal leading-tight flex-1",
    // Subtext, monospace values
    subtext: "text-[10px] font-mono opacity-50 break-all tracking-tight",
    // Active/Selected text colors handled by components based on state
  },
  spacing: {
    sectionGap: "mt-8 mb-4",
    controlGap: "gap-2.5",
    controlPadding: "py-3 px-1",
  },
  colors: {
    primary: "cyan-600", // Standard accent matching cloud panel
    primaryDark: "cyan-400", // Dark mode accent
    accent: {
      light: "rgba(6, 182, 212, 0.1)", // Light mode background accent (cyan)
      dark: "rgba(6, 182, 212, 0.15)", // Dark mode background accent
    },
    border: {
        light: "border-zinc-950/5",
        dark: "border-white/5",
    }
  },
  effects: {
    shadow: "shadow-[0_0_15px_rgba(6,182,212,0.15)]",
    shadowLight: "shadow-sm",
  }
}
